import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ControleSeapService } from './controle-seap.service';

@Component({
  selector: 'app-controle-seap',
  templateUrl: './controle-seap.component.html',
  styleUrls: ['./controle-seap.component.scss']
})
export class ControleSeapComponent implements OnInit {
  cursos: Observable<any[]>;
  matriculas: Observable<any[]>;
  matriculasConcluidas: Observable<any[]>;
  pendentes = 0;
  cursosByName ={};
  constructor(private toastr: ToastrService, private router: Router, private serve: ControleSeapService) { }

  ngOnInit() {
    // this.cursos = this.disciplinaService.get();
    this.init();
  }

  init() {
    this.cursos = this.serve.getCursos();
    this.matriculas = this.serve.getMatriculas();
    this.matriculasConcluidas = this.serve.getMatriculasConcluidas();
    this.sizePendentes();

    this.serve.getCursosStatic().then(res => {
      this.cursosByName = {}
      res.forEach(element => {
        this.cursosByName[element.val().name] = element.val();
        this.cursosByName[element.val().name].id = element.key;
      });
    })
  }

  view() {
    this.router.navigate(['/controle-seap/lista-matriculas/1']);
    
  }

  listaMatriculas() {
    this.router.navigate(['/controle-seap/lista-matriculas']);
    
  }
  listaMatriculasConcluidas() {
    this.router.navigate(['/controle-seap/lista-matriculas-concluidas']);
    
  }
  addMatricula() {
    this.router.navigate(['/controle-seap/add-matricula']);

  }
  listaCursos() {
    this.router.navigate(['/controle-seap/lista-cursos']);
    
  }
  addCurso() {
    this.router.navigate(['/controle-seap/add-curso']);
  }

  sizePendentes() {
    this.matriculas.subscribe(res => {
      if (!res || !res.length) {
        this.pendentes = 0;
      } else {
        let aux = 0;
        for(const x in res) {
          if (res[x]) {
            const diff = new Date(res[x].endDate).getTime() - new Date().getTime();
            if(Math.ceil(diff/(1000 * 60 * 60 * 24)) <= 10) {
              aux += 1;
            }
          }
        }
        this.pendentes = aux;
      }
    })
  }
  uploadCsv(fileInput) {
    
    let file = fileInput.target.files[0];
    let reader: FileReader = new FileReader();
         reader.readAsText(file);
         reader.onload = (e) => {
          let csv: any = reader.result;
          let allTextLines = [];
          allTextLines = csv.split(/\r|\n|\r/);
          const arr = [];
          for(let x in allTextLines) {
            if (allTextLines[x].indexOf('Curso') === 0) 
              continue;
            if (allTextLines[x].indexOf(',,,') === 0) 
              continue;
            if (!allTextLines[x].length) 
              continue;
            const line = allTextLines[x].split(',');
            if (!this.cursosByName[line[0].trim()]){
              console.log(allTextLines[x])
              this.toastr.error('Uma ou mais matrícula informada não possui o curso cadastrado no sistema!');
              return;
            }
              
            const ans = {
              curso: this.cursosByName[line[0].trim()].id,
              cursoName: this.cursosByName[line[0].trim()].name,
              name: line[2].trim(),
              startDate: this.getFormated(line[1]),
              endDate: this.getEndDate(this.getFormated(line[1]), this.cursosByName[line[0].trim()].time),
              penitenciaria: line[3]
            }
            arr.push(ans);
          }
          this.serve.addArrayMatricula(arr)
      }
  }

  getFormated(s) {
    const aux = s.split('/');
    return aux[2] + '-' + aux[1] + '-' + aux[0];
  }
  
  two(s) {
    if (s.toString().length === 1 ) {
      return "0" + s;
    }
    return s;
  }

  getDate(x){
    return `${x.getFullYear()}-${this.two(x.getMonth()+1)}-${this.two(x.getDate())}`;
  }

  getEndDate(s, time) {
    time += 10;
    const x = new Date(s.replace('-', '/').replace('-', '/'));
    const ts = x.setDate(x.getDate() + time);
    const newDate = new Date(ts);

    let totalSundays = 0;
    for (var i = new Date(s.replace('-', '/').replace('-', '/')); i <= newDate; ){
      if (i.getDay() == 0){
          totalSundays++;
      }
      i.setTime(i.getTime() + 1000*60*60*24);
    }
    newDate.setTime(newDate.getTime() + 1000*60*60*24*totalSundays)
    if(newDate.getDay() == 0)
      newDate.setTime(newDate.getTime() + 1000*60*60*24)

    this.getDate(newDate)

    return this.getDate(newDate)
  }
}
